import { LOAD_PAYSLIPS, LOAD_PAYSLICES_USER } from './types'
// eslint-disable-next-line import/no-cycle
import { IPayslipsActions, IPayslipsPayload, IPayslipPayload } from './actions'
import { ILoadingAndFailure } from '../../types/interfaces'

export const initState = {
	payslips: {
		originalData: [],
		tableData: [],
		pagination: null,
		isLoading: false,
		isFailure: false
	} as IPayslipsPayload & ILoadingAndFailure,
	payslipDetail: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IPayslipPayload & ILoadingAndFailure
}

export default (state = initState, action: IPayslipsActions) => {
	switch (action.type) {
		case LOAD_PAYSLIPS.START:
			return {
				...state,
				payslips: {
					...state.payslips,
					isFailure: false,
					isLoading: true
				}
			}
		case LOAD_PAYSLIPS.DONE:
			return {
				...state,
				payslips: {
					...initState.payslips,
					originalData: action.payload.originalData,
					tableData: action.payload.tableData,
					pagination: action.payload.pagination,
					isLoading: false,
					isFailure: false
				}
			}
		case LOAD_PAYSLIPS.FAILED:
			return {
				...state,
				payslips: {
					...initState.payslips,
					isFailure: true,
					isLoading: false
				}
			}

		case LOAD_PAYSLICES_USER.START:
			return {
				...state,
				payslipDetail: {
					...state.payslipDetail,
					isFailure: false,
					isLoading: true
				}
			}
		case LOAD_PAYSLICES_USER.DONE:
			return {
				...state,
				payslipDetail: {
					data: action.payload.data,
					isLoading: false,
					isFailure: false
				}
			}
		case LOAD_PAYSLICES_USER.FAILED:
			return {
				...state,
				payslipDetail: {
					...state.payslipDetail,
					isFailure: true,
					isLoading: false
				}
			}

		default:
			return state
	}
}
